import {
  PALETTE_COLOR_MAPPING,
  PALETTE_THEME_SCHEMA_DARK,
  PALETTE_THEME_SCHEMA_LIGHT,
  TYPESCALE_MAPPING,
} from './GlobalStylesConstants.js';
import {
  printRefPaletteTokens,
  printSystemColorTokens,
  printTypescaleTokens,
} from './GlobalStylesUtils.js';

export const GlobalStylesTokens = `
  :root {
    /* palette refs */
    ${printRefPaletteTokens(PALETTE_COLOR_MAPPING)}
    ${printSystemColorTokens('light', PALETTE_THEME_SCHEMA_LIGHT)}
    ${printSystemColorTokens('dark', PALETTE_THEME_SCHEMA_DARK)}
    /* typescale */
    ${printTypescaleTokens(TYPESCALE_MAPPING)}
  }
`;
